import { Component, inject, OnDestroy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { UnlockUpdateRequest } from '@app/core/states/app.actions';
import { AppState } from '@app/core/states/app.state';
import { LogEvent, SetEventProperties } from '@app/core/states/event-tracking.actions';
import { Store } from '@ngxs/store';
import { Observable, Subscription } from 'rxjs';
import { AppUpdateModalComponent } from './app-update-modal/app-update-modal.component';

@Component({
  selector: 'rk-app-update-available',
  templateUrl: './app-update-available.component.html',
  styleUrl: './app-update-available.component.scss',
  standalone: false,
})
export class AppUpdateAvailableComponent implements OnDestroy {
  currentAppHasUpdateAvailable$: Observable<boolean> = inject(Store).select(
    AppState.currentAppHasUpdateAvailable,
  );
  unlockUpdateIsLoading$: Observable<boolean> = inject(Store).select(
    AppState.unlockUpdateIsLoading,
  );
  private readonly store = inject(Store);
  private readonly dialog = inject(MatDialog);
  private readonly subscription = new Subscription();

  onCtaClick() {
    const dialogRef = this.dialog.open(AppUpdateModalComponent, {});
    this.subscription.add(
      dialogRef.afterClosed().subscribe(result => {
        if (result === true) {
          this.store.dispatch(new UnlockUpdateRequest());
        }
      }),
    );

    this.store.dispatch(
      new SetEventProperties({
        name: 'ButtonOpenUpdateApp',
        component: 'MainNav',
      }),
    );

    this.store.dispatch(new LogEvent('Button Clicked'));
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
